import React, { useState } from 'react';
import {
    Card,
    Form,
    Input,
    Button,
    Select,
    Table,
    Tag,
    message,
    Radio} from 'antd';
import { SendOutlined } from '@ant-design/icons';

const { Option } = Select;
const { TextArea } = Input;

const BulkSms = () => {
    const [form] = Form.useForm();
    const [selectedRecipients, setSelectedRecipients] = useState([]);
    const [sendingMethod, setSendingMethod] = useState('template');

    const templates = [
        { id: 1, name: 'Hoş Geldin', content: 'Sayın {AD} {SOYAD}, spor okuluna hoş geldiniz!' },
        { id: 2, name: 'Hatırlatma', content: 'Sayın {AD} {SOYAD}, yarınki antrenmanınızı hatırlatırız.' },
    ];

    const groups = [
        { id: 1, name: 'Yüzme Grubu' },
        { id: 2, name: 'Basketbol Grubu' },
        { id: 3, name: 'Futbol Grubu' },
    ];

    const recipients = [
        { id: 1, name: 'Ahmet Yılmaz', phone: '5321234567', group: 'Yüzme Grubu' },
        { id: 2, name: 'Mehmet Demir', phone: '5331234567', group: 'Basketbol Grubu' },
    ];

    const columns = [
        {
            title: 'Ad Soyad',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Telefon',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Grup',
            dataIndex: 'group',
            key: 'group',
            render: group => <Tag color="blue">{group}</Tag>,
        },
    ];

    const handleSubmit = (values) => {
        message.success('SMS gönderme işlemi başlatıldı');
    };

    return (
        <div className="bulk-sms">
            <Card style={{ marginBottom: 20 }}>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                >
                    <Form.Item
                        name="recipientType"
                        label="Alıcı Seçimi"
                        rules={[{ required: true, message: 'Lütfen alıcı türü seçin!' }]}
                    >
                        <Select
                            placeholder="Alıcı türü seçin"
                            onChange={(value) => {
                                if (value === 'group') {
                                    setSelectedRecipients(recipients);
                                } else {
                                    setSelectedRecipients([]);
                                }
                            }}
                        >
                            <Option value="group">Gruba Göre</Option>
                            <Option value="individual">Bireysel Seçim</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="groups"
                        label="Gruplar"
                        rules={[{ required: true, message: 'Lütfen en az bir grup seçin!' }]}
                    >
                        <Select
                            mode="multiple"
                            placeholder="Grup seçin"
                            options={groups.map(g => ({ label: g.name, value: g.id }))}
                        />
                    </Form.Item>

                    <Form.Item label="SMS Türü">
                        <Radio.Group
                            value={sendingMethod}
                            onChange={(e) => setSendingMethod(e.target.value)}
                        >
                            <Radio value="template">Şablon Kullan</Radio>
                            <Radio value="custom">Özel Mesaj</Radio>
                        </Radio.Group>
                    </Form.Item>

                    {sendingMethod === 'template' ? (
                        <Form.Item
                            name="template"
                            label="SMS Şablonu"
                            rules={[{ required: true, message: 'Lütfen bir şablon seçin!' }]}
                        >
                            <Select placeholder="Şablon seçin">
                                {templates.map(t => (
                                    <Option key={t.id} value={t.id}>{t.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    ) : (
                        <Form.Item
                            name="message"
                            label="SMS Metni"
                            rules={[{ required: true, message: 'Lütfen SMS metni girin!' }]}
                        >
                            <TextArea rows={4} maxLength={160} showCount />
                        </Form.Item>
                    )}

                    <Form.Item>
                        <Button type="primary" icon={<SendOutlined />} htmlType="submit">
                            SMS Gönder
                        </Button>
                    </Form.Item>
                </Form>
            </Card>

            <Card title="Seçili Alıcılar">
                <Table
                    columns={columns}
                    dataSource={selectedRecipients}
                    rowKey="id"
                    pagination={{ pageSize: 5 }}
                />
            </Card>
        </div>
    );
};

export default BulkSms; 